export const ILLEGAL_TEXT = '因涉嫌违反平台分享政策，无法查看';

export const UNNAMED_USER = '未命名用户';
